import utility from 'src/utils/utility'
import axios, { AxiosRequestConfig } from 'axios'
import { url, CONSTANTs } from 'src/provider/config/constant'


export const productApiCaller = axios.create({
    baseURL:  url.PRODUCT_BASE_URL 
})

productApiCaller.interceptors.request.use(
    async (config: AxiosRequestConfig<any>) => {
        const token = await localStorage.getItem('authToken')

        if(token && token != 'null') {
            config.headers!.Authorization = `Bearer ${token}`
        }
        else {
            config.headers = {
                clientId: CONSTANTs.clientId,
                signature: utility.getSignature()
            }
        }

        return config;
    },

    (err) => {
        return Promise.reject(err)
    }
)

//export default adminInstance